/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeTypeDTO } from './AttributeTypeDTO';
import {
    AttributeTypeDTOFromJSON,
    AttributeTypeDTOFromJSONTyped,
    AttributeTypeDTOToJSON,
} from './AttributeTypeDTO';

/**
 * 
 * @export
 * @interface StringSeriesAttributeDTO
 */
export interface StringSeriesAttributeDTO {
    /**
     * 
     * @type {string}
     * @memberof StringSeriesAttributeDTO
     */
    attributeName: string;
    /**
     * 
     * @type {AttributeTypeDTO}
     * @memberof StringSeriesAttributeDTO
     */
    attributeType: AttributeTypeDTO;
    /**
     * 
     * @type {string}
     * @memberof StringSeriesAttributeDTO
     */
    last?: string;
    /**
     * 
     * @type {number}
     * @memberof StringSeriesAttributeDTO
     */
    lastStep?: number;
}



/**
 * Check if a given object implements the StringSeriesAttributeDTO interface.
 */
export function instanceOfStringSeriesAttributeDTO(value: object): value is StringSeriesAttributeDTO {
    if (!('attributeName' in value) || value['attributeName'] === undefined) return false;
    if (!('attributeType' in value) || value['attributeType'] === undefined) return false;
    return true;
}

export function StringSeriesAttributeDTOFromJSON(json: any): StringSeriesAttributeDTO {
    return StringSeriesAttributeDTOFromJSONTyped(json, false);
}

export function StringSeriesAttributeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringSeriesAttributeDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeName': json['attributeName'],
        'attributeType': AttributeTypeDTOFromJSON(json['attributeType']),
        'last': json['last'] == null ? undefined : json['last'],
        'lastStep': json['lastStep'] == null ? undefined : json['lastStep'],
    };
}

export function StringSeriesAttributeDTOToJSON(value?: StringSeriesAttributeDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributeName': value['attributeName'],
        'attributeType': AttributeTypeDTOToJSON(value['attributeType']),
        'last': value['last'],
        'lastStep': value['lastStep'],
    };
}

